import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router} from "@angular/router";
import { RestUrlsConfig, GenericConfig} from '@signature-it/ngx-generic/config';
import { LanguageService, ShareDataService, SolrService as SolrServiceGeneric} from '@signature-it/ngx-generic/services';
import { ILanguage, ISearchSection} from '@signature-it/ngx-generic/interfaces';
import { SolrRequestDTO } from '@signature-it/ngx-generic/models';
import { Observable, Observer , throwError } from 'rxjs';
import {catchError, map, take} from 'rxjs/operators';
import { GroupApiService } from './group.service';
import { SharedDataService } from './shared-data.service';
import {ProductFieldDTO, SolrRequestOptionsDTO, ProductFullSolrDTO} from "@signature-it/ngx-catalogue/models";
import { ProductFieldDisplayType } from '@signature-it/ngx-catalogue/enums';

declare let _: any;

@Injectable({
    providedIn: 'root'
})
export class SolrService extends SolrServiceGeneric {

    constructor(
        protected http: HttpClient,
        protected config: RestUrlsConfig,
        protected router: Router,
        protected groupApiSvc: GroupApiService,
        protected sharedSvc: SharedDataService,
        protected langSvc: LanguageService
    ) {
        super(http, config, langSvc);
    }

    getSolr(options: SolrRequestOptionsDTO): Observable<any> {
        const parsedUrl = this.router.parseUrl(this.router.url);
        const isPromo = !!parsedUrl.queryParams.promo;
        const campaign = parsedUrl.queryParams.campaign || '';
        return new Observable((observer: Observer<any>) => {
            this.langSvc.getCurrentLanguage$().subscribe((currLang: ILanguage) => {
                if (currLang) {
                    const groupUserLinksId = options.isLeaf ? options.groupId : 1;
                    this.groupApiSvc.getUserLinksByGroup(groupUserLinksId, options.taxonomy, options.entityVar).pipe(take(1)).subscribe((userLinksFields: ProductFieldDTO[]) => {
                            this.buildSolrUrl(
                                userLinksFields,
                                options,
                                isPromo,
                                campaign
                            ).subscribe(responses => observer.next(responses));
                    });
                }
            });
        });
    }

	getFilters() {
		return GenericConfig.catalog_selection_fields;
	}

	handleAvailableFilters(availableFilters, request, solr_parameter_pivot) {
		availableFilters = <ProductFieldDTO[]>availableFilters;
		availableFilters.forEach(function (item: ProductFieldDTO) {
			if ((item.solr_field !== 'Name_ss') && (item.solr_field != 'FamilyName_s') && (item.solr_field !== 'FamilyName_ss')) {
				if(solr_parameter_pivot.includes(item.solr_field)) {
					request.addQueryParameter(SolrRequestDTO.PARAMETER_FACET_FIELD, `{!ex=${solr_parameter_pivot}}${item.solr_field}`);
				} else {
					request.addQueryParameter(SolrRequestDTO.PARAMETER_FACET_FIELD, `{!ex=${item.solr_field}}${item.solr_field}`);
				}
			}
			if (item.displayType === ProductFieldDisplayType.IMAGE) {
				const type = item.solr_field.replace('_ss', '_code_ss');
				request.addQueryParameter(SolrRequestDTO.PARAMETER_FACET_PIVOT, [item.solr_field, type].join());
			}
		});
	}

    getGroupsBySolr(groupsId: string, lang: ILanguage|null = null) {
        return this.http.get<ProductFullSolrDTO[]>(this.getSolrUrl+`?rows=1&fq[]=lang_code_s:${lang.code}&fq[]=cat_id_is:${groupsId}&fl=cat_id_is,cat`)
            .pipe(map((res) => {
                const response = res['response'] || {};
                return  response.docs[0] || {};
            }), catchError((error: any) => throwError(error)));
    }

}
